export default __webpack_public_path__ + "imgs/house-fve.jpg";